import React, {Component} from "react";
import T from "../t/T";
import "./Button.scss";

export default class Button extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.type === "submit") {
            document.addEventListener("keydown", this.enterKeyListener);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.enterKeyListener);
    }

    enterKeyListener = (event) => {
        if (event.key === "Enter") {
            this.onClickHandler(event);
        }
    };

    onClickHandler = (event) => {
        event && event.preventDefault();
        event['proppedValues'] = {...this.props}
        this.props.onClick(event);
    }

    render() {
        const { className = "", customClasses = "", buttonText = "", type = "button", mode = "default", size = null, selected = false, name = "", children = null, tooltip = "", config = {} } = this.props;

        return <button className={`${className} button button-${mode} ${selected && "button-" + mode + "-selected"} ${size ? "button-" + size : ""} ${customClasses}`} type={type} name={name} onClick={this.onClickHandler} {...config} title={tooltip}>
            { children ?? <T token={buttonText} /> }
        </button>;
    }
}

// Created at 2022/11(November)/07(Monday)
